<template>
<div>
    <v-dialog light persistent v-model="stats" class="cardUp">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="loaded" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong>{{ configEvento.raceTitle }} - STATISTICHE PASSAGGI</strong><span style="float:right">Num iscritti: {{elencoIscritti.length}} </span>
                    </td>
                </tr>
                <tr v-for="n in listaIntermedi " :key="'titolo'+n">
                    <td width="10%" class="frazioniTitle">{{configEvento['titolo'+n]}}</td>
                    <td width="10%" class="frazioniValue">{{mappaIntermedi[n]}} </td>
                </tr>
            </table>
            <v-btn round class="black  white--text" @click="stats=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="settings" width="500px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table style="width: 100%" class="mb-3">
                <tr>
                   <td @click="settingsTab = 1">Mostra/Nascondi colonne</td>
                   <td @click="settingsTab = 2">Fitri</td>
                </tr>
                
            </table>
            <table v-if="settingsTab == 1" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=3>
                        <strong> IMPOSTAZIONI LIVE</strong><span style="float:right">Partecipanti: {{elencoIscritti.length}} </span>
                    </td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra divisione</td>
                    <td width="10%" :class="'frazioniValue ' + ( showDivisione ? 'green white--text' : '' )" @click="applySettings('showDivisione', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showDivisione ? 'green white--text' : '' )" @click="applySettings('showDivisione', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Pos Assoluta</td>
                    <td width="10%" :class="'frazioniValue ' + ( showPosAssoluta ? 'green white--text' : '' )" @click="applySettings('showPosAssoluta', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showPosAssoluta ? 'green white--text' : '' )" @click="applySettings('showPosAssoluta', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra PosDivisione</td>
                    <td width="10%" :class="'frazioniValue ' + ( showPosDivisione ? 'green white--text' : '' )" @click="applySettings('showPosDivisione', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showPosDivisione ? 'green white--text' : '' )" @click="applySettings('showPosDivisione', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra PosMF</td>
                    <td width="10%" :class="'frazioniValue ' + ( showPosMF ? 'green white--text' : '' )" @click="applySettings('showPosMF', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showPosMF ? 'green white--text' : '' )" @click="applySettings('showPosMF', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Sesso</td>
                    <td width="10%" :class="'frazioniValue ' + ( showSesso ? 'green white--text' : '' )" @click="applySettings('showSesso', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showSesso ? 'green white--text' : '' )" @click="applySettings('showSesso', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Pettorale</td>
                    <td width="10%" :class="'frazioniValue ' + ( showPettorale ? 'green white--text' : '' )" @click="applySettings('showPettorale', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showPettorale ? 'green white--text' : '' )" @click="applySettings('showPettorale', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Nazione</td>
                    <td width="10%" :class="'frazioniValue ' + ( showNazione ? 'green white--text' : '' )" @click="applySettings('showNazione', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showNazione ? 'green white--text' : '' )" @click="applySettings('showNazione', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Atleta</td>
                    <td width="10%" :class="'frazioniValue ' + ( showAtleta ? 'green white--text' : '' )" @click="applySettings('showAtleta', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showAtleta ? 'green white--text' : '' )" @click="applySettings('showAtleta', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Categoria</td>
                    <td width="10%" :class="'frazioniValue ' + ( showCategoria ? 'green white--text' : '' )" @click="applySettings('showCategoria', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showCategoria ? 'green white--text' : '' )" @click="applySettings('showCategoria', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Pos. Categoria</td>
                    <td width="10%" :class="'frazioniValue ' + ( showPosCategoria ? 'green white--text' : '' )" @click="applySettings('showPosCategoria', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showPosCategoria ? 'green white--text' : '' )" @click="applySettings('showPosCategoria', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Squadra</td>
                    <td width="10%" :class="'frazioniValue ' + ( showSquadra ? 'green white--text' : '' )" @click="applySettings('showSquadra', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showSquadra ? 'green white--text' : '' )" @click="applySettings('showSquadra', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Giri</td>
                    <td width="10%" :class="'frazioniValue ' + ( showGiri ? 'green white--text' : '' )" @click="applySettings('showGiri', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showGiri ? 'green white--text' : '' )" @click="applySettings('showGiri', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra orario</td>
                    <td width="10%" :class="'frazioniValue ' + ( showOrario ? 'green white--text' : '' )" @click="applySettings('showOrario', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showOrario ? 'green white--text' : '' )" @click="applySettings('showOrario', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Tempo</td>
                    <td width="10%" :class="'frazioniValue ' + ( showTempo ? 'green white--text' : '' )" @click="applySettings('showTempo', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showTempo ? 'green white--text' : '' )" @click="applySettings('showTempo', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Distacco</td>
                    <td width="10%" :class="'frazioniValue ' + ( showGap ? 'green white--text' : '' )" @click="applySettings('showGap', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showGap ? 'green white--text' : '' )" @click="applySettings('showGap', false)">NO</td>
                </tr>
                <tr v-if="isUltra()">
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra metri</td>
                    <td width="10%" :class="'frazioniValue ' + ( showMetri ? 'green white--text' : '' )" @click="applySettings('showMetri', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showMetri ? 'green white--text' : '' )" @click="applySettings('showMetri', false)">NO</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR">Mostra Batteria</td>
                    <td width="10%" :class="'frazioniValue ' + ( showBatteria ? 'green white--text' : '' )" @click="applySettings('showBatteria', true)">SI</td>
                    <td width="10%" :class="'frazioniValue ' + ( !showBatteria ? 'green white--text' : '' )" @click="applySettings('showBatteria', false)">NO</td>
                </tr>
            </table>
            <table v-if="settingsTab == 2" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong> IMPOSTAZIONI FILTRI</strong>
                    </td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Partecipanti originali</td>
                    <td width="10%" class="frazioniValue">{{partecipantiOriginali}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Partecipanti filtrati</td>
                    <td width="10%" class="frazioniValue">{{elencoIscritti.length}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Divisioni nei partecipanti</td>
                    <td width="10%" class="frazioniValue">{{divisioniOriginali}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Filtro divisioni</td>
                    <td width="10%" class="frazioniValue">{{configEvento.filtroDivisioni}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Filtro sesso</td>
                    <td width="10%" class="frazioniValue">{{configEvento.filtroSesso}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Filtro categorie</td>
                    <td width="10%" class="frazioniValue">{{configEvento.filtroCategorie}}</td>
                </tr>
                <tr>
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">Filtro sottoclassifica</td>
                    <td width="10%" class="frazioniValue">{{configEvento.filtroSottoclassifica}}</td>
                </tr>
               
            </table>
            <v-btn round class="black  white--text" @click="settings=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="addClockDialog" width="500px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%; width:400px">
            <table v-if="loaded" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong>Aggiungi {{rilevamentoSelectedTitle}}</strong>
                    </td>
                </tr>
                <tr>
                    <v-text-field v-if="isMultiDay()" style="padding: 3px; color: white; background-color: white" v-model="clockToAdd" label="Inserire formato YYYY-MM-dd-hh:mm:ss.SSS" mask="####-##-##-##:##:##.###" return-masked-value outline clearable></v-text-field>
                    <v-text-field v-else style="padding: 3px; color: white; background-color: white" v-model="clockToAdd" label="Inserire formato hh:mm:ss.SSS" mask="##:##:##.###" return-masked-value outline clearable></v-text-field>
                </tr>
            </table>
            <v-layout align-start row wrap justify-center class="mt-1">
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  red--text" @click="annullaOrario()">Annulla</v-btn>
                </v-flex>
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  green--text" @click="salvaOrario()">Salva</v-btn>
                </v-flex>
            </v-layout>

        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="filtroDialog" width="340px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <v-flex v-if="isMultiDivisione()" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaDivisioni" v-model="divisioneSelected" :label="'Divisione'" single-line persistent-hint :hint="'Divisione'" @input="changedDivisione"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaSesso" v-model="sessoSelected" :label="'Sesso'" single-line persistent-hint :hint="'Sesso'" @input="changedSex"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaCategorie" v-model="categoriaSelected" :label="'Categoria'" single-line persistent-hint :hint="'Categoria'" @input="changedCategoria"></v-select>
            </v-flex>
            <v-flex  v-if="mostraNazione" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaNazioni" v-model="nazioneSelected" :label="'- seleziona nazione - '" single-line persistent-hint :hint="'Nazione'" @input="changedNazione"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-btn small round outline class="red--text" @click="annullaFiltro()">Annulla filtro</v-btn>
                    <v-btn small round outline class="green--text" @click="filtroDialog=false">Applica</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="dettaglio" class="cardUp" width="600px" scrollable style="max-width:600px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="currentItem != undefined" style="width: 100%" class="">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                        <strong style="float: left">
                            <span class="mr-2 ml-1 white--text">{{ currentItem.pett }}</span>

                            <country-flag :country="currentItem.nazione" size="small" class="" />
                            {{currentItem.cognome }}
                            {{ currentItem.nome }}
                            <br />
                            <span class="ml-5">
                                <small>{{
                                                        currentItem.squadra
                                                    }} </small></span>
                        </strong>
                        <v-icon @click="dettaglio=false" class="ma-0 pa-0 white--text" style="float:right">close</v-icon>
                    </td>
                </tr>
            </table>
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                <tr>
                    <td width="30%" class="pr-2 frazioniTitle frazioniValueR">Divisione</td>
                    <td width="70%" class="frazioniValue"><strong>{{currentItem.divisione }}</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Pos. Ass.</td>
                    <td :class=" color + ' darken-2 frazioniTitleFinale'"><strong>{{currentItem.posAss }}°</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Pos. Div.</td>
                    <td class="frazioniValue "><strong>{{currentItem.posDiv }}°</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Pos. Cat.</td>
                    <td class="frazioniValue "><strong>{{currentItem.posCat }}°</strong> - Cat: {{currentItem.categoria }} </td>
                </tr>
                <tr v-if="showMedia">
                    <td class="pr-2 frazioniTitle frazioniValueR">Media {{configEvento.unitaMedia}}</td>
                    <td class="frazioniValue ">{{currentItem.media }} </td>
                </tr>
                <tr v-if="isOCR()">
                    <td class="pr-2 frazioniTitle frazioniValueR">Bracciali</td>
                    <td :class=" color + ' darken-2 frazioniTitleFinale'"><strong>{{currentItem.col_bands }}</strong></td>
                </tr>
                <tr>
                    <td class="  pa-1" colspan=2>
                        <strong>Dettaglio PASSAGGI</strong>
                    </td>
                </tr>
                <tr v-if="showBatteria">
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Batteria</td>
                    <td width="90%" :class=" color + ' darken-2 frazioniTitleFinale'">{{currentItem.batteria }}</td>
                </tr>
                <tr>
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Guntime</td>
                    <td width="90%" :class=" color + ' darken-2 frazioniTitleFinale'">{{currentItem.guntime }}</td>
                </tr>
            </table>
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                <tr v-if="!isMultilap()">
                    <td width="10%" class=""></td>
                    <td width="10%" class="frazioniTitle">Fraz</td>
                    <td width="10%" class="frazioniTitle">Tempo</td>
                    <td width="10%" class="frazioniTitle">Orario</td>
                    <!--td width="10%" class="frazioniValue">{{currentItem['pos'+n]}}</td-->
                </tr>
                <tr v-else>
                    <td width="10%" class=""></td>
                    <td width="10%" class="frazioniTitle">Fraz</td>
                    <td width="10%" class="frazioniTitle">Tempo</td>
                    <td width="10%" class="frazioniTitle">Orario</td>
                    <!--td width="10%" class="frazioniValue">{{currentItem['pos'+n]}}</td-->
                </tr>
                <!--tr v-if="!isMultilap()" v-for="n in listaIntermedi " :key="'titoloDettaglio_'+n">
                    <td width="10%" class="frazioniTitle frazioniValueR pr-2">{{configEvento['titolo'+n]}}<span style="float:right" class="mr-2" v-if="isAdmin()" @click="delClock(n, currentItem['clock'+n])">
                            <v-icon class="red--text" small>delete</v-icon>
                        </span></td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{currentItem['fraz'+n]}} </td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{currentItem['tempo'+n]}}<span class="ml-4" v-if="isAdmin()" @click="addClock(n, 'tempo')">
                            <v-icon small>add</v-icon>
                        </span></td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{currentItem['clock'+n]}} <span class="ml-4" v-if="isAdmin()" @click="addClock(n, 'orario')">
                            <v-icon small>add</v-icon>
                        </span></td>
                </tr-->
                <tr v-if="isMultilap()" v-for="item in currentRilevamenti " :key="'titoloDettaglio'+item.lap">
                    <td width="10%" class="frazioniTitle">{{item.lap}}<span style="float:right" class="mr-2" v-if="isAdmin()" @click="delClock(1, item.clock)">
                            <v-icon class="red--text" small>delete</v-icon>
                        </span></td>
                    <td width="10%" class="frazioniValue frazioniValueR ">{{riduci(item.fraz) }}</td>
                    <td width="10%" class="frazioniValue  frazioniValueR">{{ riduci(item.time)}}<span class="ml-4" v-if="isAdmin()" @click="addClock(item, 'tempo')">
                            <v-icon small>add</v-icon>
                        </span></td>
                    <td width="10%" class="frazioniValue frazioniValueR ">{{ item.clock}}<span class="ml-4" v-if="isAdmin()" @click="addClock(item, 'orario')">
                            <v-icon>add</v-icon>
                        </span></td>
                    <!--td width="10%" class="frazioniValue">{{currentItem['pos'+n]}}</td-->
                </tr>
                <tr v-if="!isMultilap()" v-for="n in getFields() " :key="'dettaglioIntermedioRow'+n.label+'_'+n.splitNum" >
                    <td width="10%"  :class="'no-wrap text-xs-right pr-2 '+ n.color ">{{n.label }}</td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{  getFieldValue(currentItem, n) }} </td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{  getFieldValue(currentItem,  {fieldType: 'tempo', splitNum: n.splitNum} ) }} </td>
                    <td width="10%" class="frazioniValue frazioniValueR">{{  getFieldValue(currentItem,  {fieldType: 'clock', splitNum: n.splitNum} ) }} </td>

                </tr>
            </table>
            <table v-if="showGap && currentItem != undefined && currentItem.distacco1 !== '' " style="width: 100%" class="mb-3">
                <tr v-if="showGap && currentItem.distacco1 !== ''">
                    <td class="  pa-1" colspan="2">
                        <strong>DISTACCHI</strong>
                    </td>
                </tr>
                <tr v-if="showGap && currentItem.distacco1 !== ''">
                    <td width="50%" class="frazioniTitle frazioniValueR pr-2">Dal primo</td>
                    <td width="50%" class="frazioniValue ">{{currentItem.distacco1 }}</td>
                </tr>
                <tr v-if="showGap && currentItem.distacco2 !== ''">
                    <td width="50%" class="frazioniTitle frazioniValueR pr-2">Dal precendente</td>
                    <td width="50%" class="frazioniValue">{{currentItem.distacco2 }}</td>
                </tr>
            </table>
            <v-btn round outline small class="black  black--text" @click="dettaglio=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>

     <v-dialog light persistent v-model="dettaglioBands" class="cardUp" width="600px" scrollable style="max-width:600px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="currentItem != undefined" style="width: 100%" class="">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                        <strong >REGISTRA BRACCIALI
                        </strong>
                        <v-icon @click="dettaglioBands=false" class="ma-0 pa-0 white--text" style="float:right">close</v-icon>
                    </td>
                </tr>
            </table>
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                <tr>
                    <td width="30%" class="pr-2 frazioniTitle frazioniValueR">Divisione</td>
                    <td width="70%" class="frazioniValue"><strong>{{currentItem.divisione }}</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Cognome</td>
                    <td class="frazioniValue "><strong>{{currentItem.cognome }}</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Nome</td>
                    <td class="frazioniValue "><strong>{{currentItem.nome }}</strong></td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Pettorale</td>
                    <td :class=" color + ' darken-2 frazioniTitleFinale'"><strong>{{currentItem.pett }}</strong> </td>
                </tr>
                <tr>
                    <td class="pr-2 frazioniTitle frazioniValueR">Bracciali</td>
                    <td class="frazioniValue "><strong>{{currentItem.col_bands }}</strong> </td>
                </tr>
            </table>
           
             <table v-if=" currentItem != undefined && isAdmin() && isOCR()" style="width: 100%" class="mb-3">
                <tr class="mb-4">
                    <td colspan="4" class="frazioniTitle"><strong>IMPOSTA BRACCIALI - Attuali {{ currentItem.bands }}</strong> </td>
                </tr>
            </table>
             <table v-if=" currentItem != undefined && isAdmin() && isOCR()" style="width: 100%" class="mb-3">
                <tr>
                    <td width="25%" class="frazioniValue"><span @click="setBands(currentItem, 3)" class="green darken-2 white--text pa-2 pl-4 pr-4 cardStats"><strong>3</strong></span></td>
                    <td width="25%" class="frazioniValue"><span @click="setBands(currentItem, 2)" class="green white--text pa-2 pl-4 pr-4 cardStats"><strong>2</strong></span></td>
                    <td width="25%" class="frazioniValue"><span @click="setBands(currentItem, 1)" class="green lighten-2 white--text pa-2 pl-4 pr-4 cardStats"><strong>1</strong></span></td>
                    <td width="25%" class="frazioniValue"><span @click="setBands(currentItem, 0)" class="red white--text pa-2 pl-4 pr-4 cardStats"><strong>0</strong></span></td>
                </tr>
            </table>
            <v-btn round outline small class="black  black--text" @click="dettaglioBands=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>

    <v-toolbar app color="black" dark v-if="showButtons">
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0 mt-2" src="../assets/images/Logo.png" style="height: 45px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span v-if="isAdmin()" class="mr-4">
            <v-icon @click="downloadConfig()">settings</v-icon>
        </span>
         <span v-if="isAdmin()" class="mr-4">
            <v-icon @click="downloadParticipants()">people</v-icon>
        </span>
        <span v-if="showPrint || isAdmin()" class="mr-4">
            <v-icon @click="print()">print</v-icon>
        </span>
        <span v-if="showDownload || isAdmin()" class="mr-4">
            <v-icon @click="download()">download</v-icon>
        </span>
         <span v-if="showDownload || isAdmin()" class="mr-4">
            <v-icon color="red" @click="download(true)">download</v-icon>
        </span>
        <span v-if="isAdmin()" class="mr-4">
            <v-icon @click="forceReload()">refresh</v-icon>
        </span>
        <span class="mr-4">
            <v-icon @click="stats =true">equalizer</v-icon>
        </span>
        <span class="mr-4">
            <v-icon :class="getClasseFiltro()" @click="filtroDialog =true">filter_list</v-icon>
        </span>
        <span class="mr-2">
            <v-icon :class="filterToggle ? 'red--text': ''" @click="toggleSearch()">search</v-icon>
        </span>
        <!--v-icon
                v-if="filterPreferiti"
                class="mr-4 yellow--text"
                @click="togglePreferiti()"
                >star</v-icon
            >
            <v-icon v-else class="mr-4 yellow--text" @click="togglePreferiti()"
                >star_border</v-icon
            -->
        <!--span>
            <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
            <v-icon v-else @click="compatta = !compatta">expand</v-icon>
        </span-->
        <!--span>
            <v-icon @click="refreshData()">refresh</v-icon>
        </span-->
        <v-layout align-start row wrap justify-center :class=" color + '  darken-2 p-2  v-toolbar--fixed'" style="width:100%; margin-top:55px">
            <span class="white--text mr-2"><strong>{{ raceTitle }}</strong></span>
        </v-layout>
        <!--v-layout v-if="isMobileMode()" align-end row wrap justify-end :class=" color + '  darken-2 p-2  v-toolbar--fixed ml-1'" style="margin-top:55px"> <strong>{{ raceTime }}</strong>
        </v-layout-->
    </v-toolbar>
    <v-toolbar app color="red" dark v-if="showTimer">
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0 mt-2" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 40px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
            <span class="display-2 white--text" style=""  v-if="isDesktopMode()"><strong  >{{ raceTime }}</strong></span>
    </v-toolbar>
    <v-progress-linear v-if="showProgressBar" background-color="black" :color="color + ' darken-2'" class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>
    <v-layout v-if="showTimer" align-start row wrap justify-center class="mt-5">
    </v-layout>
    
    <v-layout v-if="isMobileMode() && configOK" align-start row wrap justify-center class="mt-5">
        <v-flex flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5 mt-4" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr style="height:1px">
                        <td style="height:1px" colspan="3"></td>
                    </tr>
                    <tr v-if="getUltimoPassaggio(props.item) !== undefined" class="pa-2 ">
                        <td colspan="3" class="cardUp pa-1" style="">
                            <strong :class=" getColor('color'+props.item.divisione )" style="
                                                    float: left;
                                                    margin: -4px;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                {{ props.item.posDiv }}
                            </strong>
                            <span style="float: left">
                                <small class="ml-0 mr-2"></small>

                                <country-flag :country="props.item.nazione" size="small" />
                                {{ props.item.cognome }}
                                {{ props.item.nome }}
                            </span>
                            <span @click="setCurrentItem(props.item)" class="mt-1 p-0" style="
                                                    float: right;
                                                    color: white;
                                                    margin-right: 10px;

                                                ">
                                <v-icon class="white--text pa-0">list</v-icon>
                            </span>
                            <br />
                            <span class="ml-3"> <small class="ml-2"><span class="ml-2"> #{{ props.item.pett }} </span><span class="ml-2">{{
                                                    props.item.squadra
                                                }} </span> </small></span>

                        </td>
                    </tr>

                    <tr v-if="getUltimoPassaggio(props.item) !== undefined" class="pb-2">
                        <td width="40%" class="frazioniValueRow no-wrap">
                            PASSAGGIO
                        </td>
                        <td width="40%" class="frazioniTitleRow ">
                            <strong>{{ getUltimoPassaggio(props.item) }}</strong>
                        </td>
                        <td v-if="isOCR()" width="20%" class="frazioniValueRow no-wrap" @click="setCurrentBands(props.item)">
                            <small>Bands: {{ props.item.col_bands }}</small>
                        </td>
                        <td v-else width="20%" class="frazioniValueRow no-wrap">
                            <small></small>
                        </td>
                    </tr>

                    <tr v-if="getUltimoPassaggio(props.item) !== undefined" class="pb-2">
                        <td width="40%" class="frazioniValueRow no-wrap">
                            <strong>{{props.item.posCat }}°</strong> <small> Cat. {{props.item.categoria }}</small>
                        </td>
                        <td width="40%" class="frazioniTitleRow ">
                            <strong>{{ getUltimoTempo(props.item) }}</strong>
                        </td>
                        <td v-if="isUltra()" width="20%" :class=" color + ' darken-2 frazioniTitleFinale no-wrap'">
                            <small>{{ getFieldValue(props.item, {fieldType: 'distanza'}) }}</small>
                        </td>
                        <td v-else width="20%" :class=" color + ' darken-2 frazioniTitleFinale no-wrap'">
                            <small>{{ props.item.distacco1 }}</small>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
    <v-layout v-if="isDesktopMode() && configOK" align-start row wrap justify-center :class=" this.showButtons ? 'mt-5' : 'mt-5' ">
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5 mt-4" v-if="itemsF.length > 0">
            <v-data-table :items="itemsF" hide-actions style="width: 100%;" class="mb-5">
                <template slot="headers" slot-scope="props" v-if="showHeaders">
                    <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                        <th v-if="showDivisione" class="black--text text-xs-center">Div</th>
                        <th v-if="showSesso" class="black--text text-xs-center" @click="orderBy('sesso')">Sex</th>
                        <th v-if="showPosAssoluta" class="black--text text-xs-center" @click="orderBy('posAss')">Pos</th>
                        <th v-if="showPosMF" class="black--text text-xs-center" @click="orderBy('posMF')">Pos M/F</th>
                        <th v-if="showPosDivisione" class="black--text text-xs-center" @click="orderBy('posDiv')">Pos Div</th>
                        <th v-if="showPettorale" class="black--text text-xs-center" @click="orderBy('pett')">Bib</th>
                        <th v-if="showAtleta" class="black--text text-xs-center" @click="orderBy('atleta')">Name</th>
                        <th v-if="showCategoria" class="black--text text-xs-center" @click="orderBy('categoria')">Cat</th>
                        <th v-if="showPosCategoria" class="black--text text-xs-center" @click="orderBy('posCat')">P.Cat</th>
                        <th v-if="showSquadra" class="black--text text-xs-center" @click="orderBy('squadra')">Team</th>
                        <!--th v-for="f in fields " :key="'__fieldTitle'+f" class="black--text text-xs-center" @click="orderBy(getFieldName(f))">{{ getFieldName(f) }}</th-->
                        <th v-if="showBatteria" class="black--text text-xs-center" @click="orderBy('batteria')">Wave</th>
                        <th v-if="showGiri" class="black--text text-xs-center" @click="orderBy('laps')">Giri</th>
                        <th v-if="showMetri" class="black--text text-xs-center">Metri</th>
                        <th v-if="showOrario" class="black--text text-xs-center" @click="orderBy('lastClock')">Orario</th>
                        <th v-if="showTempo" class="black--text text-xs-center" @click="orderBy('lastTime')">Time</th>
                        <!--th v-for="f in fields " :key="'__fieldTitle'+f" class="black--text text-xs-center" @click="orderBy(getFieldName(f))">{{ getFieldName(f) }}</th-->
                        <th v-if="showGap" class="black--text text-xs-center">Time/Gap</th>
                        <th v-if="showMedia" class="black--text text-xs-center">Media {{configEvento.unitaMedia}}</th>
                        <th v-for="n in getFields() " :key="'intermedioTh'+n.label+'_'+n.splitNum" class="black--text text-xs-center" @click="orderBy('tempo'+n.splitNum) ">{{ n.label }}</th>
                        <th v-if="isMultilap()" v-for="n in numFrac " :key="'__frazTitle'+n" class="frazioniValue  frazioniValueR no-wrap text-xs-center" @click="orderBy('fraz'+n)">{{ - n }}</th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr style="height:0px">
                    </tr>
                    <tr v-if="configEvento.righeFisse !== undefined && props.index == configEvento.righeFisse" style="height:1px;" :class="'white'">
                        <td :class="'white'" colspan="10" style="height:1px;">
                            <!--strong>Ultimi arrivi</strong -->
                        </td>
                    </tr>
                    <tr v-if="getUltimoPassaggio(props.item) !== undefined" >
                        <td v-if="showDivisione" :class=" getColor('color'+props.item.divisione ) + ' text-xs-center'">
                            <strong>{{ props.item.divisione }}</strong>
                        </td>
                        <td v-if="showSesso" :class=" getColor('colorSesso'+props.item.sesso ) + ' text-xs-center'">
                            <strong>{{ props.item.sesso }}</strong>
                        </td>
                        <td v-if="showPosAssoluta" width="1%"  :class=" getColor('colorPosAssoluta' ) + ' text-xs-center'">
                            <strong>{{ props.item.posAss }}</strong>
                        </td>
                        <td v-if="showPosMF" width="1%" :class=" getColor('colorPosMF' ) + ' text-xs-center'">
                            <strong>{{ props.item.posMF }}</strong>
                        </td>
                        <td v-if="showPosDivisione" width="1%"  :class=" getColor('colorPosDivisione' ) + ' text-xs-center'">
                            <strong>{{ props.item.posDiv }}</strong>
                        </td>
                        <td v-if="showPettorale" @click="setCurrentItem(props.item)" width="1%" style="padding:1px"  :class=" getColor('colorPettorale' ) + ' text-xs-center'">
                            <strong>{{ props.item.pett }}</strong>
                        </td>
                        <td @click="setCurrentItem(props.item)" :class=" getColor('colorAtleta' ) + ' text-xs-left no-wrap '" >
                            <country-flag v-if="showNazione" :country="props.item.nazione" size="small" />
                            <strong style="margin-left:2px" v-if="showAtleta" >
                                {{ props.item.cognome }} {{ props.item.nome }}
                            </strong>
                        </td>
                        <td v-if="showCategoria" :class=" getColor('colorCategoria', props.item.categoria ) + ' text-xs-center nowrap'">
                            {{ props.item.categoria }}
                        </td>
                        <td v-if="showPosCategoria" :class=" getColor('colorPosCategoria', props.item.posCat ) + ' text-xs-center no-wrap'">
                            <strong>{{ props.item.posCat }}</strong>
                        </td>
                        <td v-if="showSquadra"  :class=" getColor('colorSquadra' ) + ' text-xs-left no-wrap'">
                            {{ props.item.squadra }}
                        </td>
                         <td v-if="showBatteria" :class=" getColor('colorBatteria', (props.item.batteria)  ) + ' text-xs-center'">
                            <strong>{{ props.item.batteria }}</strong>
                        </td>
                        <td v-if="showGiri" :class=" getColor('colorGiri', getUltimoPassaggio(props.item)  ) + ' text-xs-center'">
                            <strong>{{ getUltimoPassaggio(props.item) }}</strong>
                        </td>
                        <td v-if="showMetri" :class=" getColor('colorMetri' ) + ' text-xs-center'">
                            <strong>{{ getFieldValue(props.item, {fieldType: 'distanza'}) }}</strong>
                        </td>
                        <td v-if="showOrario" :class=" getColor('colorOrario' ) + ' text-xs-center no-wrap'">
                            <strong>{{(props.item.lastClock) }}</strong>
                        </td>
                        <td @click="setCurrentItem(props.item)" v-if="showTempo" :class=" getColor('colorTempo' ) + ' text-xs-center nowrap'">
                            <strong>{{ getUltimoTempo(props.item) }}</strong>
                        </td>
                        <td nowrap v-if="showGap" :class=" getColor('colorDistacco' ) + ' text-xs-center nowrap font-weight-black'">
                            {{ (props.item.distacco1) }}
                        </td>
                        <td nowrap v-if="showMedia" :class=" getColor('colorMedia' ) + ' text-xs-center nowrap'">
                            {{ riduci(props.item.media) }}
                        </td>
                        <td @click="setCurrentItem(props.item, n)" v-for="n in getFields()" :key="'intermedioRow'+n.label+'_'+n.splitNum" :class="'no-wrap text-xs-center '+ getStyle(props.index, n.color )">
                            {{ getFieldValue(props.item, n) }}
                        </td>
                        <td @click="setCurrentItem(props.item)" v-if="isMultilap()" :class="isWarningCell(props.item, n) ? 'red darken-2 frazioniValueR no-wrap white--text ' : 'frazioniValueR no-wrap ' + getStyle(props.index)" v-for="n in numFrac " :key="'__frazName'+n">
                            <span>{{ getUltimaFrazione(props.item, n) }}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5 mt-4" v-if="itemsF.length == 0">
            <v-layout align-start row wrap justify-center class="black mt-2 ">
                    <img class="menuLogo ml-0 mt-2 mr-5" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 50px" @click="gotoHome()" />
            <span class="display-4 white--text" style=""  ><strong  >{{ raceTime }}</strong></span>
                </v-layout>
        </v-flex>

    </v-layout>
    <v-layout v-if="!configOK " align-start row wrap justify-center class="mt-4 ">
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
            <v-layout class="display-1 justify-center">LIVE NON CONFIGURATO</v-layout>
        </v-flex>
    </v-layout>
    <v-footer v-if="filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
        <v-layout align-start row wrap justify-center :class=" color + '  darken-2 p-0 m-0 '" style="width:100%; ">
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText" label="Cerca cognome, team o pettorale" outline clearable append-icon="search" @input="changedSearch"></v-text-field>
            </v-flex>
        </v-layout>
    </v-footer>
    <v-footer v-if="isAdmin() && !filterToggle" fixed class="lightgrey white--text" style="height: 40px; padding: 10px">
        <span v-if="!onlyWarning" class="mr-4">
            <v-icon @click="toggleWarning()">report_problem</v-icon>
        </span>
        <span v-if="onlyWarning" class="mr-4">
            <v-icon @click="toggleWarning()" class="red--text">report_problem</v-icon>
        </span>
        <span class="mr-4">
            <v-icon @click="gotoAdmin()">settings</v-icon>
        </span>

        <span v-if="!isMobileMode()" class="black--text ml-4" style="float:right">Refresh data:<strong> {{refreshData/1000}}</strong> sec. <span v-if="indexTo > 0"> | Simulazione dati attiva</span></span>
        <span v-else class="black--text ml-4" style="float:right">{{refreshData/1000}} sec.</span>

        <v-layout align-start row wrap justify-center class="p-0 m-0 black--text">
            <span class="pa-2 ">{{itemsF.length}} righe</span>
        </v-layout>
        <v-icon class="mr-4 black--text" style="float:right" @click="pause = !pause">{{ pause ? 'play_arrow': 'pause'}}</v-icon>
        <span v-if="!isMobileMode()" :class=" pause ? 'red--text mr-4': 'green--text mr-4' " style="float:right"><strong>{{pause ? 'Paused': 'Running'}}</strong></span>
    </v-footer>
</div>
</template>

<script>
import helper from '../helper';
import dayjs from 'dayjs';
import {math} from 'mathjs'

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            showButtons: true,

            compatta: true,
            categoriaSelected: 'TUTTE',
            sessoSelected: 'TUTTI',
            divisioneSelected: 'TUTTE',
            nazioneSelected: 'TUTTE',

            listaCategorie: [],
            listaSesso: ['TUTTI', 'MASCHILE', 'FEMMINILE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            raceTitle: '',

            connection: null,

            configEvento: {},
            elencoIscritti: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            chipMap: {},
            mappaIntermedi: {},

            currentIndex: 1,
            listaIntermedi: [],

            stats: false,
            loaded: false,
            dettaglio: false,
            dettaglioBands: false,
            currentItem: null,
            currentRilevamenti: {},

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            multiDivisione: false,
            mappaDivisioni: {},
            listaDivisioni: [],

            mappaFiles: {},
            clockBatterie: {},
            clockBatterieFinish: {},

            local: undefined,
            showDivisione: false,
            showBatteria: false,
            showGap: false,
            showMedia: false,
            showPrint: false,
            showDownload: false,

            
            color: 'red',
            baseColor: 'white:black',
            numFrac: 1,
            refreshData: 60000,
            refreshPage: 300000,
            showTimer: true,
            showProgressBar: true,
            showHeaders: true,

            numRilevamentiStep: 0,

            filtroDialog: false,

            warningDelta: 2,
            warningLaps: 5,
            onlyWarning: false,

            filtraPosCat: 0,

            orderByField: null,
            direction: true,

            raceTime: '00:00:00',

            addClockDialog: false,
            clockToAdd: "",
            rilevamentoSelected: undefined,
            rilevamentoSelectedTitle: undefined,
            rilevamentoSelectedType: undefined,

            configOK: false,
            mostraNazione: false,
            listaNazioni: [],

            settings:false,
            settingsTab: 1,

            divisioniOriginali:{},

            partecipantiOriginali:0



        };
    },

    beforeCreate() {},

    created() {},

    beforeDestroy() {
        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;

        //if (this.local != undefined) {
        //  this .local = prompt("Server URL")
        //}
        //this.sport = this.$route.params.sport;

        var pref = helper.ls.get('PREFERITI_' + this.$route.params.raceID);
        console.log('Preferiti:' + JSON.stringify(pref));
        if (pref == undefined) {
            helper.ls.set('PREFERITI_' + this.$route.params.raceID, {});
            this.listaPreferiti = {};
        } else {
            this.listaPreferiti = pref;
        }

        this.isLocale = true;
        if ( window.location.hostname.indexOf("icron.it") != -1 ) {
            this.isLocale = false;
        }


        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);

        this.loadEvento();
    },

    methods: {

        loadEvento() {
            this.listaIntermedi = [];
            this.elencoIscritti = [];

            console.log(this.raceID);
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    this.configRace(response);
                } else {
                    //alert("Evento non configurato.");
                    this.configEvento = {}

                    if (this.local !== undefined) {
                        const toks = this.local.split(",");
                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                            }
                        })
                    }
                }

            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

            if (this.configEvento.liveTemplate !== undefined ) {
                let  _url = "/"+this.configEvento.liveTemplate+"/" + this.raceID + "/" + this.paramID;
                if (this.local !== undefined) _url += "/"+this.local;
                this.$router.push(_url);
                return;
            }
            

            if (this.configEvento.gunTime.indexOf(".") == -1) this.configEvento.gunTime += ".000";

            for (let i = 1; i < 100; i++) {
                //alert(this.configEvento['split' + i]) ;
                if (this.configEvento['split' + i] !== undefined) {
                    this.configEvento.numSplit = i;
                } else {
                    break;
                }
            }



            //alert(this.configEvento.numSplit);

            //this.configEvento.numSplit = parseInt(this.configEvento.numSplit);
            if (this.configEvento.timeFormat == undefined) this.configEvento.timeFormat = 'HH:mm:ss';
            if (this.configEvento.gapFormat == undefined) this.configEvento.gapFormat = 'HH:mm:ss';

            this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
            this.baseColor = this.configEvento.baseColor !== undefined ? this.configEvento.baseColor : this.baseColor;
            this.showGap = (this.configEvento.showGap !== undefined && this.configEvento.showGap == 'true') ? true : false;
            this.showMedia = (this.configEvento.showMedia !== undefined && this.configEvento.showMedia == 'true') ? true : false;
            this.numFrac = (this.configEvento.numFrac !== undefined) ? parseInt(this.configEvento.numFrac) : 0;

            this.showDivisione = (this.configEvento.showDivisione !== undefined && this.configEvento.showDivisione == 'true') ? true : false;
            this.showPosAssoluta = (this.configEvento.showPosAssoluta !== undefined && this.configEvento.showPosAssoluta == 'true') ? true : false;
            this.showPosDivisione = (this.configEvento.showPosDivisione !== undefined && this.configEvento.showPosDivisione == 'true') ? true : false;
            this.showPosMF = (this.configEvento.showPosMF !== undefined && this.configEvento.showPosMF == 'true') ? true : false;
            this.showSesso = (this.configEvento.showSesso !== undefined && this.configEvento.showSesso == 'true') ? true : false;
            this.showPettorale = (this.configEvento.showPettorale !== undefined && this.configEvento.showPettorale == 'true') ? true : false;
            this.showNazione = (this.configEvento.showNazione !== undefined && this.configEvento.showNazione == 'true') ? true : false;
            this.showAtleta = (this.configEvento.showAtleta !== undefined && this.configEvento.showAtleta == 'true') ? true : false;
            this.showCategoria = (this.configEvento.showCategoria !== undefined && this.configEvento.showCategoria == 'true') ? true : false;
            this.showPosCategoria = (this.configEvento.showPosCategoria !== undefined && this.configEvento.showPosCategoria == 'true') ? true : false;
            this.showSquadra = (this.configEvento.showSquadra !== undefined && this.configEvento.showSquadra == 'true') ? true : false;
            this.showGiri = (this.configEvento.showGiri !== undefined && this.configEvento.showGiri == 'true') ? true : false;
            this.showOrario = (this.configEvento.showOrario !== undefined && this.configEvento.showOrario == 'true') ? true : false;
            this.showTempo = (this.configEvento.showTempo !== undefined && this.configEvento.showTempo == 'true') ? true : false;
            this.showMetri = (this.configEvento.showMetri !== undefined && this.configEvento.showMetri == 'true') ? true : false;
            this.showBatteria = (this.configEvento.showBatteria !== undefined && this.configEvento.showBatteria == 'true') ? true : false;


            this.showButtons = (this.configEvento.showButtons !== undefined && this.configEvento.showButtons == 'false') ? false : true;
            this.showPrint = (this.configEvento.showPrint !== undefined && this.configEvento.showPrint == 'true') ? true : false;
            this.showDownload = (this.configEvento.showDownload !== undefined && this.configEvento.showDownload == 'true') ? true : false;

            this.showTimer = (this.configEvento.showTimer !== undefined && this.configEvento.showTimer == 'true') ? true : false;
            this.showProgressBar = (this.configEvento.showProgressBar !== undefined && this.configEvento.showProgressBar == 'false') ? false : true;
            this.showHeaders = (this.configEvento.showHeaders !== undefined && this.configEvento.showHeaders == 'false') ? false : true;


            this.refreshPage = (this.configEvento.refreshPage !== undefined) ? parseInt(this.configEvento.refreshPage) * 1000 : 300000;
            this.refreshData = (this.configEvento.refreshData !== undefined) ? parseInt(this.configEvento.refreshData) * 1000 : 60000;

            if (this.local == undefined && !this.isLocale){
                this.refreshData = 60000; 
                console.log("SONO SU INTERNET! Forzo refresh a 60 secondi ")
            }

            this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
            this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false
            this.filtraPosCat = (this.configEvento.filtraPosCat !== undefined ) ? parseInt(this.configEvento.filtraPosCat) : 0

            this.indexTo = (this.configEvento.indexTo !== undefined) ? parseInt(this.configEvento.indexTo) : -1

            this.warningDelta = (this.configEvento.warningDelta !== undefined) ? parseFloat(this.configEvento.warningDelta) : 2
            this.warningLaps = (this.configEvento.warningLaps !== undefined) ? parseFloat(this.configEvento.warningLaps) : 5

            if (this.configEvento.metriPerGiro !== undefined) this.configEvento.metriPerGiro = this.configEvento.metriPerGiro.replace(",",".");

            if (this.isOCR()) this.configEvento.criterioClass = "col_bands,tempo"

            this.fields = [];
            if (this.configEvento.fields !== undefined) {
                this.fields = this.configEvento.fields.split(",");
            }


            for (let i = 1; i < 1000; i++) {
                //alert(this.configEvento['split' + i]) ;
                if (this.configEvento['field' + i] !== undefined) {
                    console.log("aggiuto campo" + this.configEvento['field' + i]) ;

                    this.fields.push(this.configEvento['field' + i]);
                }
            }


            if (this.configEvento.batterie !== undefined) {
                let batterie = this.configEvento.batterie.split(",");
                batterie.forEach(batt => {
                    console.log("Batteria " + batt + " : " + this.configEvento['batteria' + batt])
                    let _batt = this.configEvento['batteria' + batt];
                    if (_batt !== undefined) {
                        let _battTok = _batt.split("-");
                        this.clockBatterie[batt] = _battTok[0];
                        this.clockBatterieFinish[batt] = _battTok[1];
                        
                    }
                })
            } else {
                console.log("Nessuna batteria")
            }

            this.raceTitle = this.configEvento['raceTitle'];
            for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                this.listaIntermedi.push(index);
                this.mappaIntermedi[index] = 0;

                const split = this.configEvento['split' + index];
                if (split !== undefined) {
                    const toks = split.split(",");
                    //split3=CONTADINA KM38,tagFileRef=file2,valTime=180,numLap=1
                    this.configEvento['titolo' + index] = toks[0];

                    toks.forEach(tok => {
                        if (tok.indexOf("=") !== -1) {
                            const keyval = tok.split("=");
                            this.configEvento[keyval[0] + index] = this.normalize(keyval[1]);
                        }
                    })
                }
                console.log(this.configEvento);

            }


             let res = (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)
            
            console.log(">>>>>>>>>>>>>  IS OCR:" + res)

            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            //if (this.local) _url = "/local/"+ this.raceID+ "/localLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            this.getRemoteService(_url).then((response) => {
                this.elencoIscritti = this.csvJSON(response).filter(elem => {

                    this.divisioniOriginali[elem.divisione] = this.divisioniOriginali[elem.divisione] == null ? 1 : this.divisioniOriginali[elem.divisione]+1 ;
                    this.partecipantiOriginali++;

                    let res = true;
                    if (this.configEvento.filtroCategorie) {
                        const found = this.configEvento.filtroCategorie.split(",").find(element => element === elem.categoria);
                        res = found !== undefined;
                    }
                    if (res) {
                        if (this.configEvento.filtroDivisioni) {
                            console.log("FILTRO DIVISIONI ATTIVO:" + this.configEvento.filtroDivisioni)
                            const found = this.configEvento.filtroDivisioni.split(",").find(element => element === elem.divisione);
                            res = found !== undefined;
                        }
                    }

                    if (res) {
                        if (this.configEvento.filtroSottoclassifica) {
                            console.log(" filtroSottoclassifica ATTIVO:" + this.configEvento.filtroSottoclassifica)
                            const found = this.configEvento.filtroSottoclassifica.split(",").find(element => element === elem.classif);
                            res = found !== undefined;
                        }
                    }

                    if (res) {
                        if (this.configEvento.filtroSesso) {
                            console.log(" filtroSesso ATTIVO:" + this.configEvento.filtroSesso)
                            res = this.configEvento.filtroSesso === elem.sesso;
                        }
                    }

                    if (this.configEvento.filtroPettorale !== undefined) {
                        const listaPett = this.configEvento.filtroPettorale.split(",");
                        const found = listaPett.find(element => element === elem.pett);
                        res = found !== undefined;
                    }

                    return res
                });

                if (this.elencoIscritti.length == 0) alert("Attenzione, file dei partecipanti non è valido oppure i filtri non permettono visualizzazioni")

                this.mappaDivisioni = {};
                this.mappaMetriDivisioni = {};
                this.listaDivisioni = [];
                this.listaCategorie = [];
                let mappaCategorie = {};
                 let mappaNazioni = {};

                this.listaDivisioni.push('TUTTE');
                this.listaCategorie.push("TUTTE");


                this.elencoIscritti.forEach(elem => {
                    if (elem.nazione && elem.nazione.length > 3) {
                        elem.nazione = elem.nazione.substring(0, 3).toLowerCase();
                    } else if (elem.nazione === undefined || elem.nazione === '') {
                        elem.nazione = 'ita';
                    }
                    elem.nazione = this.normalizeNaz(elem.nazione);
                     mappaNazioni[elem['nazione']] = elem['nazione'];


                    if (elem['partenza onda'] != undefined) {
                        elem.batteria = elem['partenza onda']
                    }

                    if (this.isOCR() && elem.col_bands == undefined) {
                        elem.col_bands = 0;
                    }

                    if (elem.pettorale !== undefined) {
                        elem.pett = elem.pettorale
                    } else if (elem.p !== undefined) {
                        elem.pett = elem.p
                    } else if (elem.dorsale !== undefined) {
                        elem.pett = elem.dorsale
                    } else if (elem.dors !== undefined) {
                        elem.pett = elem.dors
                    }

                    elem.rilevamenti = {};
                    for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                        elem.rilevamenti[index] = [];
                    }

                    if (elem['chip'] != undefined) {
                        if (elem['chip'].indexOf("-") !== -1) {
                            let chips = elem['chip'].split("-");
                            chips.forEach(chip => {
                                this.chipMap[chip] = elem;
                            })
                        } else {
                            this.chipMap[elem['chip']] = elem;
                        }
                    }

                    this.chipMap[elem['pett']] = elem; // aggiungo anche la possibilità di usare il pettorale come chip

                    if (elem.guntime == undefined || elem.guntime == '') {
                        elem.guntime = this.configEvento.gunTime;

                        if (this.configEvento['gunTime' + elem.divisione] !== undefined && this.configEvento['gunTime' + elem.divisione] !== '') {
                            elem.guntime = this.configEvento['gunTime' + elem.divisione];
                        }

                        if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterie[elem.batteria] !== undefined) {
                            elem.guntime = this.clockBatterie[elem.batteria];
                        }
                        if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterieFinish[elem.batteria] !== undefined) {
                            elem.finishtime = this.clockBatterieFinish[elem.batteria];
                        }
                    }

                    elem.distanzaDivisione = this.configEvento.distanza;
                    if (this.configEvento['distanza' + elem.divisione] !== undefined && this.configEvento['distanza' + elem.divisione] !== '') {
                            elem.distanzaDivisione = this.configEvento['distanza' + elem.divisione];
                    }


                    let mdiv = this.mappaDivisioni[elem['divisione']];
                    if (mdiv === undefined && elem['divisione'] != undefined) {
                        let numLaps = -1;
                        if (this.configEvento['giriDivisione' + elem['divisione']]) {
                            numLaps = parseInt(this.configEvento['giriDivisione' + elem['divisione']]);
                        }

                        let metriLaps = 0;
                        let md = this.configEvento['metriDivisione' + elem['divisione']];
                        if (md !== undefined) {
                            md = md.replace(",",".");
                            metriLaps = parseFloat(md).toFixed(2);
                            console.log("METRILAPS:" + metriLaps)
                        }

                        this.mappaDivisioni[elem['divisione']] = {
                            id: elem['divisione'],
                            numGiri: numLaps,
                            deltaMetri: metriLaps
                        };
                        //this.listaDivisioni.push(elem['divisione']);
                        console.log("Divisione aggiunta: >>" + JSON.stringify(this.mappaDivisioni[elem['divisione']]) + "<<")
                    }
                    const _cc = elem['sesso'] + " - " + elem['categoria'];
                    mappaCategorie[_cc] = elem['categoria'];
                    console.log("Categoria aggiunta: >>" + mappaCategorie[_cc]  + "<<")
                })

                //if (this.configEvento.filtroDivisioni === undefined) {
                this.listaDivisioni = Object.keys(this.mappaDivisioni);
                if (this.listaDivisioni.length > 1) {
                    this.multiDivisione = true;
                    this.listaDivisioni.unshift("TUTTE");
                }
                //  }
                this.listaDivisioni.sort();

                this.listaCategorie = Object.keys(mappaCategorie);
                if (this.listaCategorie.length > 1) {
                }
                //  }
                this.listaCategorie.sort();

                this.mostraNazione = Object.keys(mappaNazioni).length > 1;
                this.listaNazioni = Object.keys(mappaNazioni);
                this.listaNazioni.sort();
                this.listaNazioni.unshift("TUTTE");


                this.refresh(this);
                this.myInterval = setInterval(this.refresh, this.refreshData, this);
                this.myIntervalBar = setInterval(this.refreshBar, 1000, this);
                setTimeout(this.refreshAll, this.refreshPage);
            });
        },

        applySettings(propName, propValue){
            console.log(propName + ":" +  this[propName] + " --> " + propValue)
            this[propName] = propValue
        },

        isAdmin() {
            if ( this.configEvento.admin !== undefined && this.configEvento.admin == 'admin123' ) return true;
            return this.configEvento.admin !== undefined && this.configEvento.admin === ( (this.raceID + this.paramID).split("").reverse().join("")) ;
        },

        isRealTime() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('realtime') !== -1)
        },

        isMultilap() {
            return  this.isUltra() || (this.configEvento.raceType !== undefined && this.configEvento.raceType == 'multilap')
            //return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('multilap') !== -1)
        },

        isOCR() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)
        },

        isMultiDay() {
            return (this.configEvento.multiDay !== undefined && this.configEvento.multiDay == 'true')
        },


        isUltra() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ultra') !== -1)
        },

        isMultiDivisione() {
            return this.listaDivisioni.length > 1;
        },

        refreshAll() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            //alert("Riavvio pagina")
            window.location.reload();

        },

        getFieldValue(item, field) {
            if (field.fieldType == 'field') {
                //console.log(field.columnName)
                return item[field.columnName]
            } else if (field.fieldType == 'distanza') {
                let delta = 0;

                if (this.mappaDivisioni[item.divisione] && this.mappaDivisioni[item.divisione].deltaMetri) {
                    delta = parseFloat(this.mappaDivisioni[item.divisione].deltaMetri)
                }

                if (item.distanza !== undefined && !isNaN(item.distanza) ) {
                    delta += parseFloat(item.distanza)
                }

                
                const numLaps = item.rilevamenti[1].length;
                const mpg = parseFloat(this.configEvento.metriPerGiro);
                const value = parseFloat ((numLaps * mpg) +  delta ).toFixed(2);
                //console.log(value);
                return value
            } else if (field.fieldType == 'formula') {
             //   console.log(field)
             //   console.log( (this.configEvento[field.columnName.toUpperCase()]))
                
                const { evaluate } = require('mathjs')
                let formula = ( (this.configEvento[field.columnName.toUpperCase()]))
                const operatios = /[+\-\*\/\(\)]/g;
                let keys = formula.split(operatios);

                let scope =  {}
                let self = this;
                let valid = true;
                keys.forEach(function(k) {
                    //console.log(k)
                    //console.log(item[k])
                    
                    if (k && item[k] !== undefined) {
                        //console.log(self.getTime(item[k]))
                        scope[k] = dayjs(self.normalizzaTS(self.getTime(item[k]))).utc().valueOf();
                    } else {
                        valid = false;
                    }
                });

                if (valid && keys.length == Object.keys(scope).length){
                    //console.log('INPUT is:' + JSON.stringify(scope));
                    //console.log('FORMULA is:' +formula);
                    var answer = (evaluate(formula, scope)) // {"x": 3, "y": 4}
                    const _ans = dayjs( new Date(answer)).utc().format("HH:mm:ss");
                    return _ans;
                }
                return ""  
            }

            return item[field.fieldType + field.splitNum]
        },

        getColumnName(field) {
            return field.columnName
        },

        getFieldName(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[0].trim();
            }
            return key;
        },

        getFieldLabel(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[1].trim();
            }
            return key;
        },

        getFieldColor(key) {
            try{
                if (key.indexOf(":") !== -1 ) {
                    return key.split(":")[2].trim()+ " "+key.split(":")[3].trim()+"--text";
                }
            } catch {

                return "";
            }
        },

        getColor(columnName, valore) {
            let colore = this.configEvento[columnName+valore];
            if (colore === undefined) {
                colore = this.configEvento[columnName];
                if (colore === undefined) {
                    colore = this.configEvento.baseColor;
                }
            }
            if (colore !== undefined) {
                if (colore.indexOf(":") !== -1) {
                    return colore.split(":")[0] + ' ' + colore.split(":")[1] + '--text '
                } else {
                    return colore + ' white--text '
                }
            }
            return 'white black--text '
        },

        getUltimoPassaggio(item, tailNum = 1) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti && item.rilevamenti[1]) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        return (numLaps - tailNum + 1);
                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        return this.configEvento['titolo' + index];
                    }
                }
            }
            /*    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (this.isMultilap()) {
                        if (item && item.rilevamenti) {
                            let numLaps = item.rilevamenti[index].length;
                            if (tailNum <= numLaps) {
                                return this.configEvento['titolo' + index] + " " + (numLaps - tailNum + 1);
                            }
                        }
                    }

                }*/
            return undefined;
        },
        getUltimoTempo(item, tailNum = 1, riduci=true) {

            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        if (riduci) 
                            return this.riduci(item.rilevamenti[1][numLaps - tailNum]['time']);
                        else 
                            return (item.rilevamenti[1][numLaps - tailNum]['time']);

                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        return item['tempo' + index];
                    }
                }
            }

            return undefined;
        },

        getUltimoOrario(item, tailNum = 1) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        return this.riduci(item.rilevamenti[1][numLaps - tailNum]['clock']);
                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        return this.riduci(item.rilevamenti[index][numLaps - tailNum]['clock']);
                    }
                }
            }
            return undefined;
        },

        getFrazione (item, indexRil = 0, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (indexRil < numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][indexRil]['fraz']);
                        else 
                            return (item.rilevamenti[1][indexRil]['fraz']);
                    }
                }
            }
            return undefined;
        },

         getTempoFrazione (item, index = 0, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (index < numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][index]['time']);
                        else 
                            return (item.rilevamenti[1][index]['time']);
                    }
                }
            }
            return undefined;
        },

        getUltimaFrazione(item, tailNum = 1, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][numLaps - tailNum]['fraz']);
                        else 
                            return (item.rilevamenti[1][numLaps - tailNum]['fraz']);
                    }
                }
            } else {
                if (item && item.rilevamenti) {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (this.isMultilap()) {
                            let numLaps = item.rilevamenti[index].length;
                            if (tailNum <= numLaps) {
                                  if (riduci)
                                return this.riduci(item.rilevamenti[index][numLaps - tailNum]['fraz']);
                            else 
                                return (item.rilevamenti[index][numLaps - tailNum]['fraz']);

                            }
                        }
                    }
                }
            }
            return undefined;
        },

        getMinTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz < curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        getMaxTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz > curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        isWarningCell(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return item.rilevamenti[1][numLaps - tailNum]['warning']
                }
            }
            return undefined;
        },

        setCurrentItem(item, colDef) {
            console.log(colDef)
            this.currentItem = item;

            if (colDef !== undefined && colDef.columnName == 'col_bands') {
                this.setCurrentBands(item);
                return;
            }

            this.currentRilevamenti = [];
            if (item.rilevamenti[1] !== undefined) {
                this.currentRilevamenti = item.rilevamenti[1];
            }
            this.dettaglio = true;
        },

        setCurrentBands(item) {
            this.currentItem = item;
            this.dettaglioBands = true;
        },

        setBands(item, numBands){
            //alert("Premuto:" + numBands);
            item.col_bands = numBands;

            this.salvaBand(item, numBands);
           
        },

        orderBy(field) {
            console.log("Order by " + field)

            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },

        changedLabel(event) {
            console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedSex(event) {
           // console.log('Changed:' + event);
            this.sessoSelected = event;

            this.itemsF = this.filteredList();
        },

        changedDivisione(event) {
            this.divisioneSelected = event;
            this.itemsF = this.filteredList();
        },

        changedSearch(event) {
          //  console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },

        changedCategoria(event) {
           // console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedNazione(event) {
            this.nazioneSelected = event;
            this.itemsF = this.filteredList();
        },

        annullaFiltro() {
            this.sessoSelected = "TUTTI";
            this.categoriaSelected = "TUTTE";
            this.divisioneSelected = "TUTTE";
             this.nazioneSelected = "TUTTE";
            this.filtroDialog = false;
            this.itemsF = this.filteredList();
        },

        isChecked(pett) {
            console.log('is checked');
            return (
                this.listaPreferiti[pett] !== undefined &&
                this.listaPreferiti[pett] == pett
            );
        },

        refresh: function (self) {
            if (self.pause) return;
            self.currentIndex = 1;
            self.value = 0;
            self.numRilevamentiStep = 0;
            self.execute(self);
        },

        refreshBar: function (self) {
            if (self.pause) return;
            if (self.value == undefined) self.value = 0;
            // console.log("refreshBar :" + self.value)
            self.value += (100 / (self.refreshData / 1000));
            //console.log(self.value);
            if (self.value > 100) self.value = 0;

            const now = dayjs(new Date()).format('HH:mm:ss');
            this.raceTime = this.diffTime(now, this.configEvento.gunTime)
        },

        forceReload() {
            this.refresh(this);
        },

        print() {
            let logo = "/live/assets/images/Logo.png";
            let heightLogo = "50px"
            let raceDescription = ""

            if (this.configEvento.logo !== undefined) logo = this.configEvento.logo;
            if (this.configEvento.heightLogo !== undefined) heightLogo = this.configEvento.heightLogo;
            if (this.configEvento.raceDescription !== undefined) raceDescription = this.configEvento.raceDescription;

            let divisione = "";
            let sesso = "";
            if (this.divisioneSelected &&  this.divisioneSelected !== 'TUTTE') divisione = "Divisione " + this.divisioneSelected;
            if (this.sessoSelected &&  this.sessoSelected !== 'TUTTI') sesso = this.sessoSelected;

	       // let HEADERTABLE = "<table width='100%' border=0 cellpadding=0 style=\"margin-top: 0px; \">\n" + 
		    //		"	<tr><td style=\"border:0px !important\"><img src=\""+logo+"\" height=\""+heightLogo+"\"/></td></tr>\n" + 
		//		"</table>\n\n";
		   const HEADERTABLE = "<p class=\"title2\" style=\"margin-top: 10px;text-align:right; background-color:#263238; color: white  \"><img style=\"float:left\" src=\""+logo+"\" height=\""+heightLogo+"\"/>"+ this.raceTitle +"<br>Classifica generale<br> " + divisione + "&nbsp;&nbsp;&nbsp;"  + sesso+"</p>";

            const style2 = "<style>.classifica {font-family: Verdana;font-size: 11px;} .title {	font-family: Verdana;font-size: 20px;} .title2 {	font-family: Verdana;font-size: 16px; font-weight: bold; padding: 10px} td {	border-bottom:1px solid grey; vertical-align: top; }</style>";

            const myArray = this.itemsF.filter( elem => {
                return elem.lastClock !== undefined;
            });
            var result = "<table width='100%' border=0 cellpadding=2>";
            result += "<tr class='classifica' bgcolor='#c0c0c0' >";
                if (this.showDivisione) result += "<td align=center><strong>Div</strong></td>";
                if (this.showSesso) result += "<td align=center><strong>Sex</strong></td>";
                if (this.showPosAssoluta) result += "<td align=center><strong>Pos</strong></td>";
                if (this.showPosMF) result += "<td align=center><strong>Pos M/F</strong></td>";
                if (this.showPosDivisione) result += "<td align=center><strong>Pos Div</strong></td>";
                if (this.showPettorale) result += "<td align=center><strong>Pett</strong></td>";
                if (this.showAtleta) result += "<td><strong align=center>Atleta</strong></td>";
                if (this.showCategoria) result += "<td align=center><strong>Cat</strong></td>";
                if (this.showPosCategoria) result += "<td align=center><strong>P.Cat</strong></td>";
                if (this.showSquadra) result += "<td align=center><strong>Squadra</strong></td>";
                if (this.showGiri) result += "<td align=center><strong>Pass</strong></td>";
                if (this.showMetri) result += "<td  align=center><strong>Distanza</strong></td>";
                if (this.showOrario) result += "<td align=center><strong>Orario</strong></td>";
                if (this.showTempo) result += "<td align=center><strong>Tempo</strong></td>";
                if (this.showGap) result += "<td align=center><strong>Distacco</strong></td>";
                if (this.showMedia) result += "<td align=center><strong>Media "+this.configEvento.unitaMedia+"</strong></td>";

                this.getFields().forEach(elem => {
                    result +=   "<td align=right nowrap><strong>" + elem.label + "</strong></td>"; +";"
                })
                if (this.isMultilap()) {
                    for (let n=0; n<this.numFrac; n++) {
                        result +=    "<td align=center nowrap><strong>FRAZ G" +(n+1) + "</strong></td>\n"
                        if (this.isUltra())
                            result +=    "<td align=center nowrap><strong>TEMPO G" +(n+1) + "</strong></td>\n"
                    }
                }


                result += "</tr>";
            for (var i = 0; i < myArray.length; i++) {
                result += "<tr class='classifica' >";
                if (this.showDivisione) result += "<td align=center nowrap>" + myArray[i].divisione + "</td>";
                if (this.showSesso) result += "<td align=center nowrap>" + myArray[i].sesso + "</td>";
                if (this.showPosAssoluta) result += "<td align=center nowrap>" + myArray[i].posAss + "</td>";
                if (this.showPosMF) result += "<td align=center nowrap>" + myArray[i].posMF + "</td>";
                if (this.showPosDivisione) result += "<td align=center nowrap>" + myArray[i].posDiv + "</td>";
                if (this.showPosDivisioneMF) result += "<td align=center nowrap>" + myArray[i].posDivMF + "</td>";
                if (this.showPettorale) result += "<td align=center nowrap>" + myArray[i].pett + "</td>";
                if (this.showAtleta) result += "<td nowrap>" + myArray[i].cognome+" "+ myArray[i].nome + "</td>";
                if (this.showCategoria) result += "<td align=center nowrap>" + myArray[i].categoria + "</td>";
                if (this.showPosCategoria) result += "<td align=center nowrap>" + myArray[i].posCat + "</td>";
                if (this.showSquadra) result += "<td nowrap>" + myArray[i].squadra + "</td>";
                if (this.showGiri) result += "<td align=right nowrap>" + this.getUltimoPassaggio(myArray[i])  + "</td>";
                if (this.showMetri) result += "<td  align=right nowrap>" + this.getFieldValue(myArray[i], {fieldType: 'distanza'}) + "</td>";
                if (this.showOrario) result += "<td align=right nowrap>" + myArray[i].lastClock + "</td>";
                if (this.showTempo) result += "<td align=right nowrap>" + this.getUltimoTempo(myArray[i]) + "</td>";
                if (this.showGap) result += "<td align=right nowrap>" + (myArray[i].distacco1) + "</td>";
                if (this.showMedia) result += "<td align=right nowrap>" + myArray[i].media + "</td>";
                

                this.getFields().forEach(elem => {
                    result += "<td align=right nowrap>" + this.removeUndefined(this.getFieldValue(myArray[i], elem))+ "</td>";
                })
                if (this.isMultilap()) {
                    for (let n=0; n<this.numFrac; n++) {
                        result +=  "<td align=right nowrap>"+this.removeUndefined(  this.getFrazione(myArray[i], n, false) ) + "</td>";
                        if (this.isUltra())
                            result +=  "<td align=right nowrap>"+ this.removeUndefined(  this.getTempoFrazione(myArray[i], n, false) ) + "</td>";
                    }
                }
                
                result += "</tr>";
            }
            result += "</table>";

            console.log(result)

            let myWin = window.open("", "displayWindow", "width=800,height=500,status=yes,toolbar=yes,menubar=yes");

            myWin.document.open();
            myWin.document.write("<html><head><title>CLASSIFICA "+this.raceTitle +" " + divisione + " "  + sesso+"</title>");
            myWin.document.write("");
            myWin.document.write("</head><body onload='window.print()'>");
            myWin.document.write(style2);
            
            myWin.document.write(HEADERTABLE);
            
            

           // myWin.document.write("<div class='hdr'>");

            myWin.document.write(result);

           // myWin.document.write("</div>");
            myWin.document.write("</body></html>");
            myWin.document.close();

            /* 
             */
        },



       
        download(allColumns = false) {
            let divisione = "";
            let sesso = "";
            if (this.divisioneSelected && this.divisioneSelected !== 'TUTTE') divisione = "Divisione " + this.divisioneSelected;
            if (this.sessoSelected && this.sessoSelected !== 'TUTTI') sesso = this.sessoSelected;

            const myArray = this.itemsF.filter(elem => {
                return elem.lastClock !== undefined;
            });
            var result = "";
            if (this.showPosAssoluta | allColumns) result += "Pos;";
            if (this.showPettorale | allColumns) result += "Pett;";
            if (this.showAtleta | allColumns) result += "Cognome;";
            if (this.showAtleta | allColumns) result += "Nome;";
            if (this.showNazione | allColumns) result += "Naz;";
            if (this.showPosMF | allColumns) result += "Sesso;";
            if (this.showPosMF | allColumns) result += "P.Sesso;";
            if (this.showCategoria | allColumns) result += "Cat;";
            if (this.showPosCategoria | allColumns) result += "P.Cat;";
            if (allColumns) result += "Anno;";
            if (this.showSquadra | allColumns) result += "Squadra;";
            if (allColumns) result += "Tessera;";
            if (allColumns) result += "Ente;";
            if (allColumns) result += "Cod.Squadra;";
            if (this.showTempo | allColumns) result += "Tempo;";
            if (allColumns) result += "TipoClass;";
           
            if (this.showDivisione | allColumns | allColumns) result += "Div;";
            if (this.showPosDivisione | allColumns) result += "Pos.Div;";
            if (this.showGiri  ) result += "Giri;";
            if (this.showMetri ) result += "Metri;";
            if (this.showMetri  ) result += "Residuo;";
            if (this.showOrario  ) result += "Orario;";
            if (this.showGap ) result += "Distacco;";
              this.getFields().forEach(elem => {
                    result += elem.label+";"
                })
                if (this.isMultilap()) {
                    for (let n=0; n<this.numFrac; n++) {
                        result += "FRAZ G"+ (n+1) +";"
                        if (this.isUltra())
                            result += "TEMPO G"+ (n+1) +";"
                    }
                }

            result += "\n";
            for (var i = 0; i < myArray.length; i++ | allColumns) {
                if (this.showPosAssoluta | allColumns) result += myArray[i].posAss + ";";
                if (this.showPettorale | allColumns) result += myArray[i].pett + ";";
                if (this.showAtleta | allColumns) result += myArray[i].cognome + ";";
                if (this.showAtleta | allColumns) result += myArray[i].nome + ";";
                if (this.showNazione | allColumns) result += myArray[i].nazione + ";";
                if (this.showPosMF | allColumns) result += myArray[i].sesso + ";";
                if (this.showPosMF | allColumns) result += myArray[i].posMF + ";";
                if (this.showCategoria | allColumns) result += myArray[i].categoria + ";";
                if (this.showPosCategoria | allColumns) result += myArray[i].posCat + ";";
                if (allColumns) result += myArray[i].anno + ";";
                if (this.showSquadra | allColumns) result += myArray[i].squadra + ";";
                if (allColumns) result += myArray[i].tessera + ";";
                if (allColumns) result += myArray[i].ente + ";";
                if (allColumns) result += myArray[i]['codice squadra'] + ";";
                 if (this.showTempo | allColumns) result += this.getUltimoTempo(myArray[i] ) + ";";
                if (allColumns) result += "-;";
            
                if (this.showDivisione | allColumns) result += myArray[i].divisione + ";";
                if (this.showPosDivisione | allColumns) result += myArray[i].posDiv + ";";
                if (this.showGiri ) result += this.getUltimoPassaggio(myArray[i] ) + ";";
                if (this.showMetri )  result += this.getFieldValue(myArray[i], {
                    fieldType: 'distanza'
                } ) + ";";
                 if (this.showMetri ) result += myArray[i].distanza + ";";
                if (this.showOrario ) result += myArray[i].lastClock + ";";
                if (this.showGap ) result += this.riduci(myArray[i].distacco1 ) + ";";

                this.getFields().forEach(elem => {
                    result += this.getFieldValue(myArray[i], elem)+";"
                })
                if (this.isMultilap()) {
                    //alert("Eccomi")
                    //console.log("AAA")
                    for (let n=0; n<this.numFrac; n++) {
                        result += this.removeUndefined(  this.getFrazione(myArray[i], n, false) ) +";"
                        if (this.isUltra())
                            result += this.removeUndefined(  this.getTempoFrazione(myArray[i], n, false) ) +";"
                    }
                }

                result += "\n";
            }

            //console.log(result)
            result = "data:text/csv;charset=utf-8," + result;

            var encodedUri = encodeURI(result);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "classifica_"+this.raceTitle+"_"+divisione+"_"+sesso+".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },

        downloadConfig(){
            this.settings = true
            
        },

        _downloadConfig(){
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            console.log(_url);
            window.open(_url, "_new");
            
        },


        downloadParticipants(){
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            window.open(_url, "_new");
            
        },

        removeUndefined( value ){
            if (value == undefined) return "";
            return value;
        },

        execute(self) {
            let startFrom = this.mappaFiles[self.currentIndex];
            if (startFrom == undefined) {
                this.mappaFiles[self.currentIndex] = 0;
                startFrom = 0;
            }

            const _url = this.getTagsURL() + "getFileTag?indexFrom=" + startFrom + "&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + this.currentIndex + "&indexTo=" + this.indexTo;
            console.log("EXECUTE:" + _url);

            self.getRemoteService(_url).then(
                (response) => {
                    if (response.length > 0) {
                        response = "tag;clock;antenna;progr\n" + response;
                        this.numRilevamentiStep += this.popolaPassaggi(response).length;
                    }
                    console.log("NUM RIL:" + this.numRilevamentiStep)

                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        this.loaded = true;

                        if (this.isOCR()){
                             const _url = this.getDataURL() + "getFile?type=tags&idGara=" + this.raceID + "&fileName=BANDS.csv." +this.raceID + ".csv";
                             self.getRemoteService(_url).then(
                            (response) => {
                                response = "tag;bands\n" + response;
                                //console.log(response)
                                if (response.length > 0) {
                                    const bands = this.csvJSON(response)
                                    bands.forEach(elem => {
                                        //console.log(elem);
                                        let p = this.chipMap[elem['tag']];
                                        if (p !== undefined) {
                                            p['col_bands'] = elem['bands'];
                                        }
                                    })
                                    this.showClassifica(self);
                                }else  {
                                    if (this.numRilevamentiStep > 0) this.showClassifica(self);
                                    else console.log("No refresh need")
                                }
                            });

                        }else {
                            if (this.numRilevamentiStep > 0) this.showClassifica(self);
                            else console.log("No refresh need")

                        }


                    }
                }
            ).catch(
                (error) => {
                    console.log("Errore " + error);
                    self.mappaIntermedi[self.currentIndex] += 0;
                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        self.loaded = true;
                        if (this.numRilevamentiStep > 0) self.showClassifica(self);
                        else console.log("No refresh need")
                    }
                });

        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },

        compareRil(a, b, fieldName, index = 1) {
            if (a.rilevamenti[index].length === b.rilevamenti[index].length) {
                if (a.rilevamenti[index].length == 0) return 0;
                //const tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                //console.log(a);
                //console.log(b);
                //const tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                let tempoA = a[fieldName + index];
                let tempoB = b[fieldName + index];

                if (this.isMultilap()) {
                    tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                    tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                }

                //console.log("COMPARE:" +  a.rilevamenti[index].length + " - " + b.rilevamenti[index].length +" - " + tempoA + " " + tempoB);

                if (tempoA === undefined && tempoB == undefined) return 0;
                else if (tempoA === undefined) {
                    return -1
                } else if (tempoB === undefined) {
                    return 1
                }

                if (tempoA < tempoB) {
                    return -1;
                }
                if (tempoA > tempoB) {
                    return 1;
                }
                return 0;
            } else {
                return (b.rilevamenti[index].length - a.rilevamenti[index].length)
            }
        },


        compareRilUltra(a, b) {
            let tempoA = this.getFieldValue(b, {fieldType: 'distanza'})
            let tempoB = this.getFieldValue(a, {fieldType: 'distanza'})

            if (tempoA === undefined && tempoB == undefined) return 0;
            else if (tempoA === undefined) {
                return -1
            } else if (tempoB === undefined) {
                return 1
            }

            if (tempoA < tempoB) {
                return -1;
            }
            if (tempoA > tempoB) {
                return 1;
            }

            return this.compareRil(a, b, 'tempo',  1) 

        },

        compare(a, b) {
            if (this.configEvento.criterioClass !== undefined && this.configEvento.criterioClass === 'bib') {
                return parseFloat(a.pett) - parseFloat(b.pett);
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    let res = this.compareRil(a, b, index);
                    if (res != 0) return res;
                }
            }
        },

        compareClassifica(a, b) {
            if (this.configEvento.criterioClass === undefined) {
                if (this.isUltra()) {
                    return this.compareRilUltra(a, b);
                } else if (this.isMultilap()) {
                    return this.compareRil(a, b, 'tempo', 1);
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        let res = this.compareRil(a, b, 'tempo', index);
                        if (res != 0) return res;
                    }
                }
            } else {
                let criterio = this.configEvento.criterioClass.split(",");
                let res = 0;
                for (let j=0; j< criterio.length; j++ ) {
                    //this.orderByField = criterio[j];
                    if (criterio[j] ==='tempo'){
                        console.log("CLASSIFICA CON CRITERIO: " + criterio[j]+ " >> " + res)
                        for (let index = (this.configEvento.numSplit); index > 0; index--) {
                            res = this.compareRil(a, b, 'tempo', index);
                            if (res != 0) return res;
                        }
                    } else {
                        res = this.compareField(a, b, criterio[j])
                        console.log("Stesso valore: " + criterio[j]+ " >> " + res)
                        if (res != 0) return res;
                    }
                }
            }


        },

        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        clockCompare(a, b) {
            return this.compareField(a, b, 'lastClock')
        },

        showClassifica(self) {

            let mappaPosClassifica = {};

            let clockPrimo = null;
            let clockUltimo = null;

            let posAss = 1;
            let posM = 1;
            let posF = 1;

            this.elencoIscritti.sort(this.compareClassifica);
            this.elencoIscritti.forEach(elem => {
                let keyPos = "DIV_" + elem.divisione + "_" + elem.sesso;
                let counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posDiv = mappaPosClassifica[keyPos];
                elem.posAss = posAss++;

                if (elem.sesso === 'F') {
                    elem.posMF = posF++;
                } else {
                    elem.posMF = posM++;
                }

                keyPos += "_CAT_" + elem.categoria;
                counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posCat = mappaPosClassifica[keyPos];

                if (this.isMultilap()) {
                    let indexRil = 0;
                    elem.rilevamenti[1].forEach(rilev => {
                        const warn = this.isWarning(elem.rilevamenti[1], rilev, indexRil);
                        rilev.warning = warn;
                        if (warn) elem.warning = true;
                        indexRil++;
                    })
                }

                if (this.showMedia) {
                    elem.media = this.calcolaMedia(elem.tempo, elem.distanzaDivisione, this.configEvento.unitaMedia);
                }

                if (this.showGap) {
                    if (this.isMultilap()) {
                        
                        
                        if (clockPrimo == null) {
                            console.log("Primo")
                            //elem.distacco1 = elem.tempo;
                            elem.distacco1 = ""
                            elem.distacco2 = "";
                            clockPrimo = elem.lastTime;
                              
                            
                        } else {
                            if (elem.lastTime > clockPrimo) {
                                elem.distacco1 = "+" + this.riduci(this.diffTime(elem.lastTime, clockPrimo));
                            } else {
                                elem.distacco1 = "-";
                            }
                            if (elem.lastTime >= clockUltimo) {
                                elem.distacco2 = "+" + this.riduci(this.diffTime(elem.lastTime, clockUltimo));
                            } else {
                                elem.distacco2 = "-";
                            }
                        }
                        clockUltimo = elem.lastTime;

                            
                            
                    } else {
                        if (clockPrimo == null) {
                            console.log("Primo")
                            //elem.distacco1 = elem.tempo;
                            elem.distacco1 = ""
                            elem.distacco2 = "";
                            clockPrimo = elem.tempo;
                            if (this.isMultilap()) {
                                clockPrimo = elem.lastTime;
                            }
                        } else {
                            if (elem.tempo > clockPrimo) {
                                elem.distacco1 = "+" + this.riduci(this.diffTime(elem.tempo, clockPrimo));
                            } else {
                                elem.distacco1 = "-";
                            }
                            if (elem.tempo >= clockUltimo) {
                                elem.distacco2 = "+" + this.riduci(this.diffTime(elem.tempo, clockUltimo));
                            } else {
                                elem.distacco2 = "-";
                            }
                        }
                        clockUltimo = elem.tempo;

                    }



                  
                }

            });

            self.items = this.elencoIscritti;
            self.itemsF = this.filteredList();

        },

        isRilevamentoValido(listaRilevamentiAtleta, clock, idPassaggio, laps, guntime, finishTime, winnerTime) {
            
            const t1 = dayjs(this.normalizzaTS(this.getTime(clock)));
            const tGUN = dayjs(this.normalizzaTS(this.getTime(guntime)));
            if (t1.valueOf() < tGUN.valueOf()) return false;

            if (finishTime !== undefined && finishTime !== '') {
                const tFinish = dayjs(this.normalizzaTS(this.getTime(finishTime)));
                if (t1.valueOf() > tFinish.valueOf()) return false;
            }

            let valTime = 0;
            if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
            }
            if (listaRilevamentiAtleta.length == 0) {
                if (t1.valueOf() - tGUN.valueOf() < valTime) {
                       return false;
                }
                return true;
            }

            if (this.configEvento['type' + idPassaggio] !== undefined && this.configEvento['type' + idPassaggio] == 'last') {
                return true;
            }


            if (listaRilevamentiAtleta.length < laps) {

                let valTime = 0;
                if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                    valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                }
                let ultimoPassaggio = this.getTime(listaRilevamentiAtleta[listaRilevamentiAtleta.length - 1].clock);
                //if (ultimoPassaggio.indexOf(".") == -1) ultimoPassaggio += ".000";

                const t0 = dayjs(this.normalizzaTS(ultimoPassaggio)).utc();
                const t1 = dayjs(this.normalizzaTS(this.getTime(clock))).utc();

                if (winnerTime !== undefined) {
                    const tWinner = dayjs(this.normalizzaTS(winnerTime)).utc();
                    if (t0.valueOf() > tWinner.valueOf()) return false;
                }

                //console.log(tempoOrig);
                const diff = t1.valueOf() - t0.valueOf();
                if (diff >= valTime) {
                    return true;
                } else {
                    //if (this.configEvento.debug) {
                    console.log("Valtime > " + valTime);
                    console.log(ultimoPassaggio + " > " + t0.valueOf());
                    console.log(this.getTime(clock) + " > " + t1.valueOf());
                    console.log("DIFF:" + diff);
                    // }
                }
            } else {
                console.log("Scarto numLap superiori a quelli ammessi nel passaggio  ");
            }
            return false;
        },

        popolaPassaggi(data) {
            let index = this.currentIndex;
            console.log("popolaPassaggi>" + index);

            let lista = this.csvJSON(data);
            console.log("aggiungo >" + lista.length + " letture");
            if (this.configEvento.debug) console.log("aggiungo >" + JSON.stringify(lista));
            this.mappaFiles[index] += lista.length;

            let result = [];

            lista.forEach(elem => {
                if (elem.clock === undefined) {
                    //console.log("Time " + elem.clock + " is before cut: " + cutFrom);
                } else {

                    let laps = 1;
                    if (this.configEvento['numLap' + index] !== undefined) {
                        laps = parseInt(this.configEvento['numLap' + index]);
                    }

                    let p = this.chipMap[elem['tag']];
                    if (p !== undefined) {
                        let pettorale = p['pett'];

                        if (this.mappaDivisioni[p.divisione] !== undefined && this.mappaDivisioni[p.divisione]['numGiri'] > 0) {
                            laps = this.mappaDivisioni[p.divisione]['numGiri']
                        }

                        let _finishTime = p.finishtime;
                        //console.log("FINISH TIME>" + _finishTime + "<")
                        if ((_finishTime === '' || _finishTime == undefined) && this.configEvento['finishTime' + p['divisione']] !== undefined) {
                            _finishTime = this.configEvento['finishTime' + p['divisione']];
                        }

                        let _winnerTime = this.configEvento.winnerTime;
                        if (this.configEvento['winnerTime' + p['divisione']] !== undefined) {
                            _winnerTime = this.configEvento['winnerTime' + p['divisione']];
                        }

                        if (this.isRilevamentoValido(p.rilevamenti[index], elem.clock, index, laps, p.guntime, _finishTime, _winnerTime)) {
                            //console.log("DEBUG:>>");
                            

                            if (index == 1 && this.isRealTime()) {
                                p.guntime = elem.clock
                            }

                            const _tempo = this.getTempo(p.guntime, elem.clock);
                            const _clock = elem.clock; //this.getTime(elem.clock);
                            let _fraz = (this.diffTime(elem.clock, p.guntime, this.configEvento.frazFormat));


                            if (this.configEvento['type' + index] !== undefined && this.configEvento['type' + index] === 'last') {
                                console.log("LAST:" + this.configEvento['type' + index])
                                let obj = {
                                    pett: p.pett,
                                    time: _tempo,
                                    clock: _clock,
                                    fraz: _fraz,
                                    lap: 1
                                }

                                if (p.rilevamenti[index].length == 0)
                                    p.rilevamenti[index].push(obj);
                                else
                                    p.rilevamenti[index][0] = obj;

                            } else {

                                if (this.isMultilap()) {
                                    if (p.rilevamenti[index].length > 0) {
                                        _fraz = (this.diffTime(_tempo, p.rilevamenti[index][p.rilevamenti[index].length - 1].time , this.configEvento.frazFormat));
                                    }
                                } else {
                                    if (index > 1 && p.rilevamenti[index - 1].length > 0) {
                                        _fraz = (this.diffTime(_tempo, p.rilevamenti[index - 1][p.rilevamenti[index - 1].length - 1].time, this.configEvento.frazFormat));
                                    }
                                }

                                p.rilevamenti[index].push({
                                    pett: p.pett,
                                    time: _tempo,
                                    clock: _clock,
                                    fraz: _fraz,
                                    lap: p.rilevamenti[index].length + 1
                                });
                            }

                            if (p.rilevamenti[index].length == laps) {

                                //if (laps > 1 ) console.log("PASSAGGI CORRETTI:" + p.cognome + " " + p.pett)
                                p.clock = this.getTime(elem.clock);
                                p.tempo = this.getTempo(p.guntime, elem.clock)

                                p['tempo' + index] = this.getTempo(p.guntime, elem.clock);
                                p['clock' + index] = _clock;
                                p['fraz' + index] = _fraz; // this.getTime(_fraz);
                            }

                            p.lastClock = _clock;
                            p.lastTime = _tempo;
                            p.laps = p.rilevamenti[index].length;

                            result.push(p);
                        } else {
                            console.log("passaggio non valido:" + elem.tag + " " + p.cognome + " " + elem.clock + " >>" + JSON.stringify(p.rilevamenti[index]));
                        }
                    } else {
                        if (this.configEvento.debug) console.log("Tag " + elem.tag + " sconosciuto");
                    }

                }

            })

            this.mappaIntermedi[index] += result.length;
            return result;

        },

        isWarning(listaRil, rilevamento, indexRil) {
            if (listaRil.length > 1) {
                var utc = require('dayjs/plugin/utc')
                dayjs.extend(utc)

                let ttMin = undefined;
                if (indexRil == 0) return false;

                let indexFrom = indexRil;
                let indexTo = indexFrom + this.warningLaps;

                if (indexRil < this.warningLaps) {
                    indexFrom = 0;
                    indexTo = indexRil;
                } else {
                    indexFrom = indexRil - this.warningLaps;
                    indexTo = indexRil;
                }
                //alert(minVal)

                let last5 = listaRil.slice(indexFrom, indexTo);
                //console.log("da: " + (indexFrom) + " a: " + (indexTo) );

                let min = last5.reduce(function (prev, curr) {
                    //console.log(rilevamento.pett + " >> " + prev.fraz + " - " + curr.fraz);
                    return prev.fraz < curr.fraz ? prev : curr;
                });
                ttMin = min.fraz
                //console.log("WINNER >> " + ttMin)

                const tt0 = this.normalizzaTS(rilevamento.fraz);
                const tt1 = this.normalizzaTS(ttMin);

                const t0 = dayjs(this.getIsoDate(tt0)).utc() + 3600000;
                const tMin = dayjs(this.getIsoDate(tt1)).utc() + 3600000;

                if ((t0.valueOf()) > ((tMin.valueOf()) * this.warningDelta)) {
                    return true;
                }

            }
            return false;
        },

        getTempo(guntime, tempoRil) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(tempoRil);

            //console.log("getTempo: " + tt0+" "+ tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format(this.configEvento.timeFormat);

            //console.log(">getTempo: " +result);

            if (result === 'Invalid Date') return tempoRil;

            return result;
        },

        gotoHome() {
            this.$router.push('/');
        },

        gotoAdmin() {
            this.$router.push('/admin');
        },

        getStyle(index, n) {
            if (n != undefined) return n;
            if (index % 2 == 0) return "grey lighten-4"
            return "white"
        },

        getClasseFiltro() {
            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                return "red--text"
            } else if (this.divisioneSelected !== 'TUTTE' && this.divisioneSelected !== undefined && this.divisioneSelected !== '') {
                return "red--text"
            } else if (this.nazioneSelected !== 'TUTTE' && this.nazioneSelected !== undefined && this.nazioneSelected !== '') {
                return "red--text"
            } else if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                return "red--text"
            }
            return ''
        },

        toggleWarning() {
            this.onlyWarning = !this.onlyWarning;
            this.itemsF = this.filteredList();
        },

        toggleCompatta() {
            this.compatta = !this.compatta;
        },

        toggleSearch() {
            this.filterToggle = !this.filterToggle;
            window.scrollTo(0, 0);
        },

        togglePreferiti() {
            this.filterPreferiti = !this.filterPreferiti;
            this.showClassifica(this.raceData);
        },
        toggleItem(pett) {
            if (this.listaPreferiti[pett] == undefined) {
                this.listaPreferiti[pett] = pett;
            } else {
                this.listaPreferiti[pett] = undefined;
            }
            console.log(pett + '-->' + this.listaPreferiti[pett]);
            helper.ls.set(
                'PREFERITI_' + this.$route.params.raceID,
                this.listaPreferiti
            );
            //this.togglePreferiti();
            //this.togglePreferiti();
            //this.showClassifica(this.raceData);
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            //   console.log('categoriaSelected:' + this.categoriaSelected);

            if (this.categoriaSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    const _cat = this.categoriaSelected.substring(this.categoriaSelected.indexOf(" - ") + 3);
                    console.log(_cat)
                    var res4 =
                        p != null &&
                        p.categoria != null &&
                        p.categoria == _cat;

                    return res4;
                });
            }


             if (this.nazioneSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.nazione != null &&
                        p.nazione.toUpperCase() == this.nazioneSelected.toUpperCase();

                    return res4;
                });
            }

            //        console.log('sessoSelected:' + this.sessoSelected);

            if (this.sessoSelected !== 'TUTTI') {
                listaSearch = listaSearch.filter((p) => {
                    let sex = this.sessoSelected == 'MASCHILE' ? 'M' : 'F';
                    var res4 =
                        p != null &&
                        p.sesso != null &&
                        p.sesso == sex;

                    return res4;
                });
            }

            //       console.log('divisioneSelected:' + this.divisioneSelected);

            if (this.divisioneSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.divisione != null &&
                        p.divisione == this.divisioneSelected;

                    return res4;
                });
            }

            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }



            if (this.onlyWarning) {
                console.log("Cerco solo warning")
                listaSearch = listaSearch.filter((p) => {
                    return p.warning;
                })
                console.log("Cerco solo warning: " + listaSearch.length)
            }

            if (this.filtraPosCat > 0) {
                listaSearch = listaSearch.filter((p) => {
                    var res =
                        p != null &&
                        p.posCat <= this.filtraPosCat

                    return res;
                });
            }

            
            if (this.configEvento.righeFisse || this.configEvento.righeCoda) {
                let myArray = listaSearch.filter( elem => {
                    return elem.lastClock !== undefined;
                });
                const rCoda = parseInt(this.configEvento.righeCoda);
                const rFisse = parseInt(this.configEvento.righeFisse);

                let _righeFisse = [];
                let _righeVariabili = [];

                if ( myArray.length > rCoda ) {
                    if (this.configEvento.righeFisse) {
                        _righeFisse = myArray.slice(0,rFisse);
                    }
                }

                if (this.configEvento.righeCoda   ) {
                    _righeVariabili =  myArray.sort(this.clockCompare);
                    _righeVariabili = _righeVariabili.slice(0, rCoda).reverse();
                } 
                return _righeFisse.concat(_righeVariabili);
            }

            

            //if (this.configEvento.filtroRighe) listaSearch = listaSearch.slice(0, parseInt(this.configEvento.filtroRighe));

            return listaSearch;
        },

        addClock(itemID, tipologia) {
            console.log("addClock" + JSON.stringify(itemID) + " " + tipologia);

            if (this.isMultilap()) {
                itemID = 1;
            }

            this.rilevamentoSelected = itemID;
            this.rilevamentoSelectedTitle = tipologia + " a " + this.configEvento['titolo' + itemID];
            this.rilevamentoSelectedType = tipologia;

            this.clockToAdd = "";
            //this.rilevamentoSelected = item;
            this.addClockDialog = true;
        },

        delClock(_rilevamentoSelected, clockToDelete) {
            if (confirm("Confermi la cancellazione del rilevamento " + clockToDelete + " ? ")) {

                let _url = this.getTagsURL() + "writeFileTag?type=CANCLIVE&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + _rilevamentoSelected + "&tag=" + this.currentItem.chip + "&ts=" + clockToDelete + "&op=" + this.currentItem.pett + " " + this.currentItem.cognome + " " + this.currentItem.nome + " - " + this.configEvento.admin;
                console.log("EXECUTE UPDATE:" + _url);
                this.writeTag(_url).then(response => {
                    console.log(response);
                    this.dettaglio = false;
                    this.refreshAll()
                });
            }
        },

        salvaOrario() {
            let _orarioDef = this.clockToAdd;

            if (this.clockToAdd)

                if (this.rilevamentoSelectedType == 'tempo') {
                    _orarioDef = this.calcolaOrario(this.currentItem.guntime, this.clockToAdd);
                }

            /*if (this.clockToAdd.indexOf("+") !== -1 ) {
                const _orario = this.clockToAdd.split("+");
                _orarioDef = _orario[0];
            } else if (this.clockToAdd.indexOf("-") !== -1 ) {
                const _orario = this.clockToAdd.split("-");
                _orarioDef = _orario[0];
            } */

            if (this.isValidDate(_orarioDef)) {
                let _url = this.getTagsURL() + "writeFileTag?type=INS&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + this.rilevamentoSelected + "&tag=" + this.currentItem.chip + "&ts=" + _orarioDef + "&op=" + this.currentItem.pett + " " + this.currentItem.cognome + " " + this.currentItem.nome + " - " + this.configEvento.admin;
                console.log("EXECUTE UPDATE:" + _url);
                this.writeTag(_url).then(response => {
                    console.log(response);
                    this.addClockDialog = false;
                    this.dettaglio = false;
                    this.refreshAll()
                });
            } else {
                alert("Formato orario non valido. >>" + this.clockToAdd + "<<")
            }

        },
        annullaOrario() {
            this.addClockDialog = false;
        },


        salvaBand(_rilevamentoSelected, numBands) {
              let _url = this.getTagsURL() + "writeFileTag?type=PROPERTY&idGara=" + this.raceID+"_"+this.paramID + "&id=BANDS&tag=" + _rilevamentoSelected.pett+";"+numBands ;
                this.writeTag(_url).then(response => {
                    console.log(response);
                    this.dettaglioBands = false;
                    this.showClassifica(this);
                    //this.refreshAll()
                });
        },

        getFields() {
            // if (!this.isMultilap()) {
            //console.log("getFields")
            if (this.fields && this.fields.length > 0) {
                let lista = [];
                this.fields.forEach(elem => {
                    let label = this.getFieldLabel(elem);
                    let color = this.getFieldColor(elem);;
                    elem = this.getFieldName(elem)

                    let _elem = elem.replace("FRAC_", "")
                    _elem = _elem.replace("CLOCK_", "")
                    _elem = _elem.replace("TIME_", "")
                    let fieldType = "tempo"
                    if (elem.startsWith("FRAC_")) {
                        fieldType = "fraz"
                    } else if (elem.startsWith("CLOCK_")) {
                        fieldType = "clock"
                    } else if (elem.startsWith("FORMULA_")) {
                        fieldType = "formula"
                    } else if (elem.startsWith("COL_") || elem.startsWith("GUNTIME")) {
                        fieldType = "field"
                    } else if (elem.startsWith("metri")) {
                        fieldType = "distanza"
                        const _obj = {
                            splitNum: 0,
                            fieldType: fieldType,
                            columnName: elem,
                            label: label,
                            color: color
                        };
                        // console.log(_obj)
                        lista.push(_obj);
                    }

                    if (fieldType == "field" || fieldType == "formula" ) {
                        const _obj = {
                                    splitNum: -1,
                                    fieldType: fieldType,
                                    columnName: _elem.toLowerCase(),
                                    label: label,
                                    color: color
                                };
                                // console.log(_obj)
                                lista.push(_obj);   
                    }else {
                        for (let index = (this.configEvento.numSplit); index > 0; index--) {
                            if (this.configEvento['titolo' + index] === _elem) {
                                const _obj = {
                                    splitNum: index,
                                    fieldType: fieldType,
                                    columnName: elem,
                                    label: label,
                                    color: color
                                };
                                // console.log(_obj)
                                lista.push(_obj);
                            }
                        }
                    }
                })
                return lista;
            }
            return this.listaIntermedi;
            //  } else {
            //      return this.listaIntermedi;
            //  }
        }

    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px;
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    _border-radius: 0px 0px 7px 7px;
    _font-weight: bold;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
    _border-radius: 0px 5px 5px 0px;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 0px 0px 7px 7px;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 5px 0px 0px 5px;
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
    _border-radius: 0px 0px 7px 7px;
}

.passaggio {
    background-color: lightgrey;
    text-align: center;
    color: green;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 5px 5px 5px 5px;
    _font-weight: bold;
}

.laps {
    text-align: center;
    color: white;
    font-style: italic;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
}

.cardUp {
    background-color: #212121;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardStatsHeader {
    background-color: #212121;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}
</style>
